<template>
  <v-data-table :headers="computedHeader" :items="sortedData" class="elevation-1 table" hide-actions>
    <template v-slot:headers="props">
      <tr>
        <th v-for="header in props.headers" :key="header.text" @click="changeSort(header.value)" :class="[
          'column sortable',
          pagination.descending ? 'desc' : 'asc',
          header.value == 'Equipment' && pagination.sortBy == 'id' ? 'active' : (header.value == pagination.sortBy ? 'active' : ''),
        ]">
          {{ header.text }}
          <v-icon small
            v-show="header.value === pagination.sortBy || header.value == 'Equipment' && pagination.sortBy == 'id'">
            {{ pagination.descending ? 'arrow_downward' : 'arrow_upward' }}
          </v-icon>
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr>
        <td>
          <v-checkbox v-model="inverterState[simpleString(props.item.Equipment)]" primary hide-details>
          </v-checkbox>
        </td>
        <td v-for="(items, key, index) in props.item" :key="index" v-show="index >= 1" :class="index == 1
          ? 'text-xs-center'
          : dataCondition(props.item.id, index, items) == 'No Data' ||
            dataCondition(props.item.id, index, items) == 'NC'
            ? 'error--text text-xs-center'
            : 'number--text text-xs-center'
          ">
          {{ dataCondition(props.item.id, index, items) }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import _ from "lodash";
import service from "@/services/Scb.js";
import service1 from "@/services/zone-monitoring.js";
import { mixin, mapGettersMixin, miscellaneous } from "@/util/mixin/index.js";
import { mapMutations } from "vuex";

export default {
  mixins: [mixin, mapGettersMixin, miscellaneous],
  props: ["plantId", "dataView", "date", "chips"],
  data() {
    return {
      data: [],
      headers: [],
      ncdata: [],
      channels: [],
      localChips: [],
      inverterState: {},
      graphParameters: new Set(),
      channelCount: null,
      channelWithId: {},
      enableInverterStateWatch: false,
      pagination: {
        sortBy: "id",
        descending: false,
        page: 1,
        rowsPerPage: 500,
      },
    };
  },
  computed: {
    dateAndDataView() {
      return `${this.date} ${this.dataView}`;
    },
    sortedData() {
      return this.arraySortHandler(this.data, this.pagination.sortBy === "Equipment" || this.pagination.sortBy === "id" ? "id" : this.pagination.sortBy, this.pagination.descending ? "desc" : "asc")
    },
    computedHeader() {
      const resultHeader = [
        {
          text: "",
          value: "",
          sortable: false,
        },
      ];
      this.headers.forEach((el) => {
        const obj = _.cloneDeep(el);
        obj["align"] = "center";
        if (!el.text.includes("Ch")) {
          obj["text"] = this.$t(el.text);
        }
        resultHeader.push(obj);
      });
      return resultHeader;
    },
  },
  async created() {
    await this.setIntervalWithoutDelay(this.getTableData);
  },
  methods: {
    ...mapMutations(["SET_PROGRESS_BAR"]),
    changeSort(column) {
      if (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
    dataCondition(id, index, items) {
      if (this.ncdata[id] && this.ncdata[id].indexOf(`${index - 4}`) !== -1) {
        return "NC";
      } else if (index > 1) {
        if (items == null) {
          return "No Data";
        } else {
          return parseFloat(items).toFixed(2);
        }
      }
      return items;
    },
    async getTableData() {
      try {
        this.SET_PROGRESS_BAR(true);
        let response = await service.getAdvancedStingInverterData(
          this.plantId,
          this.dataView,
          this.date
        );
        let count = await service1.getStringCount(this.plantId);
        this.SET_PROGRESS_BAR(false);
        this.data = response.data.message.data;
        this.data.forEach((el) => {
          let key = this.simpleString(el.Equipment);
          this.$set(this.inverterState, key, false);
        });
        this.ncdata = count.data.message;
        this.headers = response.data.message.headers;
        this.graphParameters = new Set(response.data.message.graphParameters);
        this.$emit("availableData", this.graphParameters);
        this.channelCount = response.data.message.channelCount;
        this.enableInverterStateWatch = true;
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    inverterSelected(key) {
      key = this.simpleString(key);
      this.channels = [];
      const originalObject = {};
      originalObject[key] = this.data.filter(
        (d) => this.simpleString(d.Equipment) == key
      )[0];

      const { id } = originalObject[key];

      if (this.inverterState[key]) {
        // When checkbox is checked
        for (let i = 0; i < this.channelCount; i++) {
          this.channels.push(i + 1);
        }

        if (this.ncdata[id] !== undefined) {
          Object.entries(this.ncdata[id]).forEach(([key, value]) => {
            if (this.channels.includes(value) === false) {
              let key = this.channels.indexOf(parseInt(value));
              this.channels.splice(key, 1);
            }
          });
        }

        this.channels
          .filter((val) => !this.localChips.includes(id.concat("-ch-", val)))
          .forEach((el) => {
            this.localChips.push(id.concat("-ch-", el));
          });

        this.channelWithId[id] = this.channels;
      } else {
        // When checkbox is unchecked
        for (let i = 1; i <= this.channelCount; i++) {
          let localKey = this.localChips.indexOf(id.concat("-ch-", i));
          this.channels.push(i);
          if (localKey > -1) {
            this.localChips.splice(localKey, 1);
            this.localChips = [...this.localChips];
          }
        }
        delete this.channelWithId[id];
      }
    },
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi);
      }
    },
    data() {
      this.data.forEach((item) => {
        if (this.enableInverterStateWatch) {
          this.$watch(
            "inverterState." + this.simpleString(item.Equipment),
            function () {
              this.inverterSelected(item.Equipment);
            }
          );
        }
      });
    },
    dateAndDataView() {
      this.getTableData();
    },
    localChips() {
      this.$emit("chipsUpdate", {
        chips: this.localChips,
        chipsObj: this.channelWithId,
      });
    },
    chips() {
      const removeLast2String = (arr) => {
        let chip = arr.map((el) => {
          return el.split("-ch-")[0];
        });
        const uniqueChip = [...new Set(chip)];
        return uniqueChip;
      };

      const currentChip = removeLast2String(this.chips);
      const oldChip = removeLast2String(this.localChips);
      if (!this.isArrEqual(currentChip, oldChip)) {
        const unCheckedCheckbox = this.arrDifference(oldChip, currentChip)[0];
        const inverterStateKey = this.data.filter(
          (el) => el.id === unCheckedCheckbox
        )[0];
        this.inverterState[
          this.simpleString(inverterStateKey.Equipment)
        ] = false;
      }
    },
  },
};
</script>

<style scoped>
.table {
  height: calc(100vh - 305px);
  overflow: auto;
  display: flex;
}

.table th {
  z-index: 1;
  position: sticky;
  top: 0;
  color: var(--v-extraGrey) !important;
  background: var(--v-primary-base) !important;
}
</style>

<style>
.table .v-table__overflow {
  overflow: auto;
}
</style>